module.exports = __webpack_public_path__ + "static/img/ma.5db52d8a.png";